import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { log } from '../lib/logger';

export default function AuthLaunch() {
  const [params] = useSearchParams();
  useEffect(() => {
    const next = params.get('next') || '';
    let decoded = '';
    try { decoded = decodeURIComponent(next); } catch { decoded = next; }
    const url = (() => { try { return new URL(decoded); } catch { return null; } })();
    let access_token = '', refresh_token = '', type = '', token_hash = '', token = '';
    const collect = (s: URLSearchParams) => {
      access_token ||= s.get('access_token') || '';
      refresh_token ||= s.get('refresh_token') || '';
      type ||= s.get('type') || '';
      token_hash ||= s.get('token_hash') || '';
      token ||= s.get('token') || '';
    };
    if (url) {
      if (url.hash?.startsWith('#')) collect(new URLSearchParams(url.hash.slice(1)));
      collect(new URLSearchParams(url.search));
    } else {
      const frag = decoded.includes('#') ? decoded.split('#',2)[1] : '';
      const raw = frag || (decoded.split('?')[1] || '');
      collect(new URLSearchParams(raw));
    }

    log.debug('[AUTH-LAUNCH] Extracted parameters:', {
      has_access_token: !!access_token,
      has_refresh_token: !!refresh_token,
      has_token: !!token,
      has_token_hash: !!token_hash,
      type
    });

    sessionStorage.setItem('reset_tokens', JSON.stringify({ access_token, refresh_token, type, token_hash, token, ts: Date.now() }));
    window.location.replace('/auth/callback?t=1');
  }, [params]);
  return null;
}
